import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';

import splitLongWords from 'utils/splitLongWords';

import OrderViewInformationSection from './OrderViewInformationSection';
import OrderViewInformationSectionTitle from './OrderViewInformationSectionTitle';

const styles = () => ({
  listItem: {
    padding: 0,
    display: 'block',
    marginTop: 20,
  },
});
const OrderViewInformationSalesRepresentative = props => (
  <OrderViewInformationSection>
    <OrderViewInformationSectionTitle>
      Sales Representative
    </OrderViewInformationSectionTitle>
    <List disablePadding>
      {props['Sales Representative'].map(salesRepresentativeItem => (
        <ListItem
          key={salesRepresentativeItem.ID}
          className={props.classes.listItem}
          disableGutters
        >
          <Typography component="span" gutterBottom>
            {splitLongWords(`${salesRepresentativeItem['First Name']} ${salesRepresentativeItem['Last Name']}`)}
          </Typography>
          <Typography
            variant="caption"
            component="span"
          >
            {salesRepresentativeItem.Email
              ? splitLongWords(`${salesRepresentativeItem.Phone} ${salesRepresentativeItem.Email}`)
              : salesRepresentativeItem.Phone}
          </Typography>
        </ListItem>
      ))}
    </List>
  </OrderViewInformationSection>
);

OrderViewInformationSalesRepresentative.propTypes = {
  'Sales Representative': PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
    'First Name': PropTypes.string.isRequired,
    'Last Name': PropTypes.string.isRequired,
    Email: PropTypes.string,
    Phone: PropTypes.string.isRequired,
  })).isRequired,
  classes: PropTypes.shape({
    listItem: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(OrderViewInformationSalesRepresentative);



// WEBPACK FOOTER //
// ./src/components/workflow/OrderViewInformation/OrderViewInformationSalesRepresentative.js